import { handleActions } from 'redux-actions';

import * as actions from './actions';
import * as base from "../BaseReducers";


const initialState = Object.assign({},
  base.ListState,
  base.DetailState,
);

export default handleActions(
  {
    [actions.transactionListLoadRequest]: (state, action) => base.listLoadRequest(state, action),
    [actions.transactionListLoadComplete]: (state, action) => base.listLoadComplete(state, action),
    [actions.transactionListLoadError]: (state, action) => base.listLoadError(state, action),

    [actions.transactionDetailLoadRequest]: (state, action) => base.detailLoadRequest(state, action),
    [actions.transactionDetailLoadComplete]: (state, action) => base.detailLoadComplete(state, action),
    [actions.transactionDetailLoadError]: (state, action) => base.detailLoadError(state, action),
  },
  initialState
);
